export enum MESSAGES_ERROR {
  'The store order can not created' = 'No se puede crear el pedido de la tienda.',
  'There is not enough inventory at the location' = 'No hay suficiente inventario en la locación',
  'The reserve can not created' = 'La reserva no se puede crear',
  'There is not enough inventory' = 'No hay suficiente inventario',
  'Please check your inventory, there are skus that are in an ongoing process.' = 'Por favor revise su inventario, hay skus que se encuentran en proceso.',
  'Please check your inventory, generate supply to the inventory of this product at the suggested location' = 'Por favor revise su inventario, genere suministro al inventario de este producto en la locación sugerida',
  'The warehouse does not have an inventory location priority name' = 'No se puede crear el conteo: La bodega seleccionada no tiene asignada una prioridad/ruta óptima de ubicación.',
}

export enum KEYS {
  'location' = 'Locación',
  'sku_id' = 'SKU ID',
  'external_id' = 'EXTERNAL ID',
  'sku_external_id' = 'EXTERNAL ID',
}
